// Izracun racuna na kasi - strana ekrana.
//
// PAZI: ovo je zrcalo datoteke server/helpers/kasaRacun.js. Mjerodavan je
// SERVER - on racuna ono sto se sprema, ispisuje i salje Poreznoj. Ovdje se
// racuna samo zato da kasir vidi zbroj dok tipka, bez odlaska na posluzitelja
// nakon svake znamenke.
//
// Formula mora biti ista do zadnje lipe, inace bi ekran pokazivao jedan iznos
// a racun nosio drugi. Da to ne odluta, postoji test koji obje izvedbe pusta
// na istim nasumicnim racunima i usporeduje rezultat:
//
//   node server/helpers/kasaRacun.mirror.test.js
//
// Ako mijenjate formulu, mijenjajte je na oba mjesta i pustite taj test.

const broj = (v) => {
  if (typeof v === 'number') { return isFinite(v) ? v : 0 }
  if (v === null || v === undefined) { return 0 }
  const n = parseFloat(String(v).replace(',', '.'))
  return isFinite(n) ? n : 0
}

const zaokruzi2 = (v) => Math.round((broj(v) + Number.EPSILON) * 100) / 100

const izracunajStavku = (ulaz, redniBroj) => {
  const s = ulaz || {}
  const kolicina = zaokruzi2(s.kolicina)
  const cijena = zaokruzi2(s.cijena)
  const popustPosto = zaokruzi2(s.popustPosto)
  const stopa = zaokruzi2(s.pdvStopa)

  const bruto = zaokruzi2(kolicina * cijena)
  const popust = zaokruzi2(bruto * popustPosto / 100)
  const zaPlatiti = zaokruzi2(bruto - popust)
  const osnovica = zaokruzi2(zaPlatiti / (1 + stopa / 100))
  const pdv = zaokruzi2(zaPlatiti - osnovica)

  return {
    rb: redniBroj,
    sifra: s.sifra ? String(s.sifra) : '',
    naziv: s.naziv ? String(s.naziv) : '',
    mjera: s.mjera ? String(s.mjera) : '',
    usluga: s.usluga === true,
    kolicina: kolicina,
    cijena: cijena,
    popustPosto: popustPosto,
    popust: popust,
    pdvStopa: stopa,
    osnovica: osnovica,
    pdv: pdv,
    ukupno: zaPlatiti,
    nabavna: zaokruzi2(s.nabavna)
  }
}

const izracunajRacun = (ulazneStavke) => {
  const stavke = (ulazneStavke || []).map((s, i) => izracunajStavku(s, i + 1))

  let ukupno = 0
  let osnovicaUkupno = 0
  let pdvUkupno = 0
  let popustUkupno = 0
  let bezPdv = 0

  const grupe = new Map()

  stavke.forEach(s => {
    ukupno = zaokruzi2(ukupno + s.ukupno)
    osnovicaUkupno = zaokruzi2(osnovicaUkupno + s.osnovica)
    pdvUkupno = zaokruzi2(pdvUkupno + s.pdv)
    popustUkupno = zaokruzi2(popustUkupno + s.popust)

    if (s.pdvStopa === 0) {
      bezPdv = zaokruzi2(bezPdv + s.ukupno)
      return
    }
    const g = grupe.get(s.pdvStopa) || {stopa: s.pdvStopa, osnovica: 0, iznos: 0}
    g.osnovica = zaokruzi2(g.osnovica + s.osnovica)
    g.iznos = zaokruzi2(g.iznos + s.pdv)
    grupe.set(s.pdvStopa, g)
  })

  const poStopama = Array.from(grupe.values()).sort((a, b) => b.stopa - a.stopa)

  return {
    stavke: stavke,
    ukupno: ukupno,
    osnovicaUkupno: osnovicaUkupno,
    pdvUkupno: pdvUkupno,
    popustUkupno: popustUkupno,
    bezPdv: bezPdv,
    poStopama: poStopama
  }
}

export {broj, zaokruzi2, izracunajStavku, izracunajRacun}
export default {broj, zaokruzi2, izracunajStavku, izracunajRacun}
